import {PassInfo, QualifyInfo} from '@/types/api/qualify';
import {PASS_QUALIFY_STATUS, QUALIFY_STATUS} from '@/dicts/qualify';
import {cookies} from '@/modules/App';

export function isPassportUser() {
    const loginType = cookies.get('bce-login-type');
    return !!loginType && loginType.toLowerCase() === 'passport';
}

/**
 * 看当前认证状态是否需要pass同步
 * @param info
 * @returns
 */
function checkInfoNeedPassSync(info: QualifyInfo) {
    const isInit = !info || (info && !info.person && !info.company);
    if (!isInit) {
        const isPerson = info.person && !info.company;
        // 个人转企业失败，且个人未高级 + 企业认证失败
        const companyFail
            = info?.company?.status && [
                QUALIFY_STATUS.RETURN,
                QUALIFY_STATUS.WITHDRAW,
            ].includes(info?.company?.status)
            && info?.company?.person?.gradeStatus !== 'SENIOR';
        if (!isPerson) {
            return companyFail;
        }
        // 仅当个人高级认证状态没有完成
        return info?.person?.gradeStatus !== 'SENIOR';
    }
    return true;
}

/**
 * 判断是否需要获取passInfo的信息同步
 */
export function needPassInfo(info: QualifyInfo) {
    const isPass = isPassportUser();
    if (!isPass) {
        return false;
    }

    // 记录用户是否拒绝同步
    if (info.grayUser) {
        const rejectSync = sessionStorage.getItem('reject_sync');
        if (rejectSync) {
            return false;
        }
    }

    return checkInfoNeedPassSync(info);
}

/**
 * 初始化实名账号是否需要pass同步状态
 * @param {*} info: qualify/info，实名信息
 * @param {*} passInfo: passinfo，passport账号实名信息
 * @returns info
 */
export function initInfoPassSync(info: QualifyInfo, passInfo: PassInfo) {
    const {status} = passInfo;
    // 只认可pass高级认证可以同步
    info.needPassSync
        = status === PASS_QUALIFY_STATUS.SENIOR
        // 个人认证未高级
        && ((info?.person?.gradeStatus !== 'SENIOR'
            && info?.person?.personSeniorStatus !== QUALIFY_STATUS.AUDIT
        )
        // 企业认证失败,且个人未高级
        || (info.company && info.company.status === QUALIFY_STATUS.RETURN
            && (!info.company.personal_pass
                || info.company.personal_pass
                && info.company.person.gradeStatus !== 'SENIOR'
            )
        )
        // 未认证状态
        || (!info.person && !info.company));
    info.passInfo = passInfo;
    return info;
}
